import { render, staticRenderFns } from "./DataTableBlockText.vue?vue&type=template&id=32632792&scoped=true&"
import script from "./DataTableBlockText.vue?vue&type=script&lang=js&"
export * from "./DataTableBlockText.vue?vue&type=script&lang=js&"
import style0 from "./DataTableBlockText.vue?vue&type=style&index=0&id=32632792&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32632792",
  null
  
)

export default component.exports